import { createSlice } from "@reduxjs/toolkit";
import { ILeadAssignSettingState } from "./leadAssignSettingModel";
import {
  deleteAutoLeadAssignSetting,
  getAllAutoLeadAssigns,
  getLeadAssignSettings,
  insertAutoLeadAssignSetting,
  updateAutoLeadAssign,
} from "./services/leadAssignSetting.services";

const initialState: ILeadAssignSettingState = {
  loading: false,
  error: "",
  LeadAssignEmployeeID: "",
  LeadAssignEmployeeList: [],
  LeadAssignSettingDetails: {
    LeadAutoAssign: false,
    SectorWiseAssign: false,
    EmployeeID: "",
  },
};

const leadAssignSettingSlice = createSlice({
  name: "leadAssignSetting",
  initialState,
  reducers: {
    clearLeadAssignSettingDetails: (state) => {
      state.LeadAssignSettingDetails = initialState.LeadAssignSettingDetails;
    },
    setLeadAssignEmployeeID: (state, action) => {
      state.LeadAssignEmployeeID = action.payload;
    },
    clearLeadAssignEmployeeID: (state) => {
      state.LeadAssignEmployeeID = initialState.LeadAssignEmployeeID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAutoLeadAssigns.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllAutoLeadAssigns.fulfilled, (state, action: any) => {
      state.loading = false;
      state.LeadAssignEmployeeList = action.payload;
    });
    builder.addCase(getAllAutoLeadAssigns.rejected, (state, action) => {
      state.loading = false;
      state.LeadAssignEmployeeList = initialState.LeadAssignEmployeeList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateAutoLeadAssign.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAutoLeadAssign.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateAutoLeadAssign.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertAutoLeadAssignSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertAutoLeadAssignSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertAutoLeadAssignSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteAutoLeadAssignSetting.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAutoLeadAssignSetting.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAutoLeadAssignSetting.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getLeadAssignSettings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getLeadAssignSettings.fulfilled, (state, action: any) => {
      state.loading = false;
      state.LeadAssignSettingDetails = action.payload;
    });
    builder.addCase(getLeadAssignSettings.rejected, (state, action) => {
      state.loading = false;
      state.LeadAssignSettingDetails = initialState.LeadAssignSettingDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  clearLeadAssignSettingDetails,
  setLeadAssignEmployeeID,
  clearLeadAssignEmployeeID,
} = leadAssignSettingSlice.actions;
export default leadAssignSettingSlice.reducer;
